import product1  from './image/ıphone.png'
import product2  from './image/canon.png'
import product3  from './image/airpods.png'
import product4  from './image/airpodsmax.png'
import product5  from './image/macbook.png'
import product6  from './image/samsung.png'
import product7  from './image/ps5.png'
import product8  from './image/smartwatch.png'
import product9  from './image/tv.png'

export const PRODUCTS = [
    {
        id : 1,
        productName : "iphone",
        price : 999.0,
        productImage:product1,
    },
    {
        id : 2,
        productName : "canon",
        price : 700.0,
        productImage:product2,
    },
    {
        id : 3,
        productName : "airpods",
        price : 180.0,
        productImage:product3,
    },
    {
        id : 4,
        productName : "airpods max",
        price : 200.0,
        productImage:product4,
    },
    {
        id : 5,
        productName : "macbook",
        price : 600.0,
        productImage:product5,
    },
    {
        id : 6,
        productName : "samsung",
        price : 400.0,
        productImage:product6,
    },
    {
        id : 7,
        productName : "ps5",
        price : 700.0,
        productImage:product7,
    },
    {
        id : 8,
        productName : "smart watch",
        price : 300.0,
        productImage:product8,
    },
    {
        id : 9,
        productName : "tv",
        price : 800.0,
        productImage:product9,
    },
]
